import Vue from 'vue';

import { FindAChipotleClickEvent } from '@/services/analytics/events';

/** For tracking 'Find A Chipotle' related link clicks */
Vue.directive('track-fac-link-click', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', e => {
      vnode.context?.$services.analytics.send(new FindAChipotleClickEvent(binding.arg ?? ''));
    });
  },
});
